/* eslint-disable valid-jsdoc */
/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import _ from 'lodash';
import { MLEndorsementUtil } from 'ml-portals-util-js';
import NavigationData from '../models/NavigationData';
import NavigationStep from '../models/NavigationStep';
import MLPortalStorageService from './MLPortalStorageService';
import MLInitPolicyChangeSteps from '../config/ml-init-policy-change-steps.json';

const {
    ML_STORAGE_KEY_NAVIGATION_STEPS
} = appConfig;

let navigationData;
const qualificationSteps = ['endorsementPupAddlInfoAndQualifications', 'endorsementPaAddlInfoAndQualification', 'endorsementHoAddlInfoAndQualifications'];
const stepsToSkipAddlInfo = ['endorsementBillingDetails', 'endorsementInterestedParties', 'endorsementProfileDetails', 'endorsementPaHouseholdMembers', 'endorsementQuoteDetails', 'endorsementTrasferToPayroll'];
const stepsToAllowQuickBind = qualificationSteps.concat(stepsToSkipAddlInfo);

function removeLobCodeFromStepName(nameOfStep) {
    return nameOfStep ? nameOfStep.replace(/pa|pup|pa|/ig, '') : undefined;
}

// startStepListenerV9
function stepChange(toStepName, fromStepName) {
    navigationData.firstSteps.forEach((step) => {
        if (step.name && step.name === removeLobCodeFromStepName(toStepName)) {
            step.isInProgress = true;
            step.isCompleted = false;
        }
    });

    navigationData.lastSteps.forEach((step) => {
        if (step.name && step.name === removeLobCodeFromStepName(toStepName)) {
            step.isInProgress = true;
            step.isCompleted = false;
        }
    });

    navigationData.firstSteps.forEach((step) => {
        if (step.name && step.name === removeLobCodeFromStepName(fromStepName)) {
            step.isInProgress = false;
            step.isCompleted = true;
        }
    });

    navigationData.lastSteps.forEach((step) => {
        if (step.name === 'EndorsementSubmitChanges') {
            if (fromStepName === 'endorsementRequiredSignatures' || fromStepName === 'endorsementVerbalAuthorization' || fromStepName === 'endorsementESignature') {
                step.isInProgress = false;
                step.isCompleted = true;
            }
        } else if (step.name && step.name === removeLobCodeFromStepName(fromStepName)) {
            step.isInProgress = false;
            step.isCompleted = true;
        }
    });
}

/**
 * This private function removes a step with certain criteria from a specified array of steps
 *
 * @param arr - The array where to find the element
 * @param displayName - This is used together with $state.current.name to find the step to remove
 * @param preserveIfCompleted - Additional restriction: if true, the search is limited only to uncompleted and in progress steps
 * @private
 */
function _removeFromStepsArray(arr, displayName, preserveIfCompleted, currentStepName) {
    preserveIfCompleted = preserveIfCompleted || false;
    const index = arr.findIndex(
        (step) => step.name === currentStepName
            && step.displayName === displayName
            && (!preserveIfCompleted || (step.isInProgress && !step.isCompleted))
    );
    if (index > -1) {
        arr.splice(index, 1);
    }
}

export default {
    init(jobType, productName, translator, initStep) {
        switch (jobType) {
            case 'PolicyChange':
                _.each(MLInitPolicyChangeSteps.firstSteps, (step) => {
                    step.isInProgress = undefined;
                    step.isCompleted = undefined;
                });
                _.each(MLInitPolicyChangeSteps.lastSteps, (step) => {
                    step.isInProgress = undefined;
                    step.isCompleted = undefined;
                });
                navigationData = new NavigationData(MLInitPolicyChangeSteps, translator);
                if (productName && productName === 'HOPHomeowners') {
                    navigationData.lastSteps.splice(navigationData.lastSteps.indexOf('endorsementAddlInfoToPurchase') + 1, navigationData.lastSteps.indexOf('endorsementAddlInfoToPurchase') + 2);
                }
                break;
            default:
                break;
        }

        if (navigationData) {
            stepChange(initStep || 'endorsementEffectiveDate');
        }

        return this.getData();
    },

    setJobNumber(jobNumber) {
        if (navigationData) navigationData.jobNumber = jobNumber;
    },

    setOriginalEffectiveDate(effectiveDate) {
        if (navigationData) navigationData.effectiveDate = effectiveDate;
    },

    getData() {
        return navigationData;
    },

    addToDynamicSteps(displayName, avoidOverrideIfCompleted, currentStepName, authHeader = {}) {
        // US1163519: handle resume case (navigationData undefined)
        if (!navigationData) {
            console.warn('navigationData undefined - initializing fallback');
    
            navigationData = new NavigationData({
                firstSteps: [],
                dynamicSteps: [],
                lastSteps: []
            });
        }
    
        // US1163519 : ensure dynamicSteps always exists
        if (!navigationData.dynamicSteps) {
            navigationData.dynamicSteps = [];
        } 
    
        _removeFromStepsArray(
            navigationData.dynamicSteps,
            displayName,
            avoidOverrideIfCompleted,
            currentStepName
        );

        navigationData.dynamicSteps.push(
            new NavigationStep({
                name: currentStepName,
                displayName,
                isInProgress: true,
                isCompleted: false
            })
        );
        this.syncToPortalStorage(authHeader);
    },

    clearDynamicSteps(currentStepName) {
        navigationData.dynamicSteps = navigationData.dynamicSteps.filter((step) => {
            return step.displayName === currentStepName && step.isInProgress;
        });
        // $rootScope.$broadcast('resetAdditionalChangesModel');
    },

    removeFromDynamicSteps(displayName, preserveIfCompleted, currentStepName, authHeader = {}) {
        _removeFromStepsArray(navigationData.dynamicSteps, displayName, preserveIfCompleted, currentStepName);
        this.syncToPortalStorage(authHeader);
    },

    completeCurrentStep(details, authHeader = {} ,activeStep = {}) {
        
        const _completeStepForArray = (arr) => {
            let currentStep = activeStep;
            let filteredSteps = arr.filter((step) => step?.isInProgress === true && step?.isCompleted !== true);
            if(currentStep.mlStepName === "endorsementInterestedParties"){
                filteredSteps = arr.filter((step) => step?.isInProgress === true && step?.isCompleted !== true && step.id === details.id );
            }
            if (filteredSteps.length > 0) {
                if(!_.isEmpty(activeStep)){
                    currentStep = filteredSteps.find((item)=>item.name === currentStep.mlStepName)    
                }else{
                    [currentStep]= filteredSteps
                }   
                if (details) {
                    currentStep.details = details.data || details;
                    currentStep.fixedId = details.fixedId || undefined;
                    currentStep.pageAction = details.pageAction || undefined;
                    currentStep.driverType = details.driverType || undefined;
                    currentStep.replacedFixedId = details.replacedFixedId || undefined;
                    if(details.additionalData){
                        currentStep.additionalData = details.additionalData
                    }
                }
                currentStep.isInProgress = false;
                currentStep.isCompleted = true;
            }
        };
        _completeStepForArray(navigationData?.firstSteps);
        _completeStepForArray(navigationData?.dynamicSteps);
        _completeStepForArray(navigationData?.lastSteps);
        this.syncToPortalStorage(authHeader);
    },

    completeAllDynamicSteps(authHeader = {}) {
        const _completeStepsForArray = (arr) => {
            const filteredSteps = arr.filter((step) => step.isInProgress === true && step.isCompleted !== true);
            filteredSteps.forEach((step) => {
                step.isInProgress = false;
                step.isCompleted = true;
            });
        };
        _completeStepsForArray(navigationData.dynamicSteps);
        this.syncToPortalStorage(authHeader);
    },

    completeAllSteps(authHeader = {}) {
        const _completeStepsForArray = (arr) => {
            arr.forEach((step) => {
                step.isInProgress = false;
                step.isCompleted = true;
            });
        };
        _completeStepsForArray(navigationData.firstSteps);
        _completeStepsForArray(navigationData.dynamicSteps);
        _completeStepsForArray(navigationData.lastSteps);
        this.syncToPortalStorage(authHeader);
    },

    syncToPortalStorage(additionalHeaders = {}) {
        if (navigationData?.jobNumber) {
            MLPortalStorageService.store(navigationData.jobNumber, null, ML_STORAGE_KEY_NAVIGATION_STEPS, JSON.stringify(navigationData), additionalHeaders);
        }
    },

    retrieveFromPortalStorage(jobNumber, accountNumber, additionalHeaders = {}) {
        return MLPortalStorageService.retrieve(jobNumber, accountNumber, ML_STORAGE_KEY_NAVIGATION_STEPS, additionalHeaders).then((data) => {
            if (data) {
                navigationData = new NavigationData(JSON.parse(data));
            }
        });
    },

    retrieveFromPortalStorageEndorsement(jobNumber, additionalHeaders = {}, refreshData) {
        MLPortalStorageService.retrieve(jobNumber, null, ML_STORAGE_KEY_NAVIGATION_STEPS, additionalHeaders).then((data) => {
            if (data && !_.isEmpty(data)) {
                const savedData = new NavigationData(JSON.parse(data));
                if (!navigationData) {
                    navigationData = new NavigationData();
                }
                const currentSteps = navigationData.dynamicSteps.map((s) => s.name);
                savedData.dynamicSteps.forEach((step) => {
                    const displayName = step.displayName;
                    if (!currentSteps.includes(step.name)) {
                        navigationData.dynamicSteps.push(new NavigationStep({
                            name: step.name,
                            displayName,
                            details: step.details,
                            fixedId: step.fixedId,
                            pageAction: step.pageAction,
                            driverType: step.driverType,
                            replacedFixedId: step.replacedFixedId,
                            isInProgress: step.isInProgress,
                            isCompleted: step.isCompleted,
                            additionalData : step.additionalData,
                        }));
                    }
                });
                refreshData();
            }
        });
    },

    shouldSkipQualificationsScreen(endorsement) {
        const navDataExists = !!(navigationData && navigationData.dynamicSteps);
        if (navDataExists) {
            if (MLEndorsementUtil.isAccidentPreventionStateAndSelected(navigationData.dynamicSteps, endorsement)) {
                return false;
            }
            return (navigationData.dynamicSteps.some((step) => qualificationSteps.indexOf(step.name) > -1) ||
                navigationData.dynamicSteps.every((step) => {
                    return stepsToSkipAddlInfo.indexOf(step.name) > -1 ||
                        (step.name === 'endorsementPupVehicleOperator' && step.displayName.indexOf('Household') > -1);
                }));
        }
        return false;
    },

    shouldQuickBind() {
        return navigationData &&
            navigationData.dynamicSteps &&
            navigationData.dynamicSteps.every((step) => {
                return stepsToAllowQuickBind.indexOf(step.name) > -1;
            });
    },

    stepChange
};
